var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-link", { attrs: { to: _vm.link } }, [
    _c("div", { staticClass: "timestamp" }, [
      _vm._v(" " + _vm._s(_vm.seperator) + " "),
    ]),
    _c(
      "div",
      {
        staticClass: "message",
        class: {
          them: _vm.userID != _vm.value.UserID,
          thread: _vm.value.ThreadID,
          same: _vm.value.UserID === _vm.previous.UserID,
          bubble: _vm.bubble,
        },
      },
      [
        _vm.value.UserID !== _vm.previous.UserID
          ? _c("div", { staticClass: "message-header" }, [
              _c("span", { staticClass: "user" }, [
                _vm._v(
                  _vm._s(_vm.user.Firstname) +
                    _vm._s(
                      _vm.value.ThreadID ? " " + _vm.$ct("started-thread") : ""
                    )
                ),
              ]),
              _c("span", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.messageTime)),
              ]),
            ])
          : _vm._e(),
        _vm.value.ThreadID
          ? _c("w-fa", { attrs: { icon: ["far", "comment-dots"] } })
          : _vm._e(),
        _c("pre", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.value.Message)),
        ]),
        _vm.value.FileURL != ""
          ? _c("div", { staticClass: "download" }, [
              _vm.isAttachementImage
                ? _c(
                    "a",
                    {
                      staticClass: "img",
                      style: { backgroundImage: _vm.cssImageUrl },
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function ($event) {
                          _vm.openImage = true
                        },
                      },
                    },
                    [
                      _vm.openImage
                        ? _c(
                            "w-modal",
                            {
                              attrs: { "escape-close": "" },
                              model: {
                                value: _vm.openImage,
                                callback: function ($$v) {
                                  _vm.openImage = $$v
                                },
                                expression: "openImage",
                              },
                            },
                            [
                              _c("app-image-modal", {
                                attrs: {
                                  src: _vm.value.getFileUrl(),
                                  "image-name": _vm.value.FileName,
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.closeImage()
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "a",
                    {
                      staticClass: "file",
                      attrs: { href: _vm.value.getFileUrl(), target: "_blank" },
                    },
                    [
                      _c("w-fa", { attrs: { icon: _vm.icon } }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.value.FileName || _vm.$ct("common.download")
                          )
                      ),
                    ],
                    1
                  ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }